import { Typography, useTheme } from '@mui/material';
import { View } from 'react-native';
import { calculateDiscountedPrice } from '../utils/customFunctions';
import { usePreviewableConfig } from '../contexts/PreviewConfigContext';

interface ProductPriceProps {
    price: number;
    discount?: number;
    discountType?: 'percentage' | 'value';
    mainSize?: number;
    secondarySize?: number;
    direction?: 'row' | 'column';
}

export const ProductPrice = ({
    price,
    discount = 0,
    discountType = 'percentage',
    mainSize = 14,
    secondarySize = 12,
    direction = 'row'
}: ProductPriceProps) => {
    const theme = useTheme();
    const { config } = usePreviewableConfig();
    
    // Use Google Font if set, otherwise use local font
    const secondaryFontFamily = config.secondaryFont ? `'${config.secondaryFont}', sans-serif` : 'primaryFont';
    const hasDiscount = discount > 0;
    const finalPrice = calculateDiscountedPrice(price, discount, discountType);

    return (
        <View style={{
            flexDirection: direction === "row" ? "row" : "column",
            alignItems: direction === "row" ? "center" : "flex-start",
        }}>
            <Typography
                variant={mainSize > 16 ? "h5" : "body2"}
                sx={{
                    fontSize: mainSize,
                    fontWeight: "bold",
                    letterSpacing: 0.5,
                    fontFamily: secondaryFontFamily,
                    color: theme.palette.success.main,
                }}
            >
                {config.currency} {finalPrice}
            </Typography>

            {hasDiscount && (
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: secondarySize,
                        fontWeight: "bold",
                        letterSpacing: 0.5,
                        fontFamily: secondaryFontFamily,
                        color: theme.palette.text.disabled,
                        marginLeft: direction === "row" ? 0.5 : 0,
                        textDecorationLine: "line-through",
                    }}
                >
                    {config.currency} {price.toFixed(2)}
                </Typography>
            )}
        </View>
    );
}; 